import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import typing from "../assets/img/typing.jpg"
import colorSharp2 from "../assets/img/color-sharp2.png";
import fd from "../assets/img/fd.jpg"
import 'animate.css';
import TrackVisibility from 'react-on-screen';


export const Projects = () => {

    
  const projects = [
    {
      title: "Typing Playground",
      description: "Skill Test & Rating",
      imgUrl: typing,
      hostlink:"https://typingplayground.netlify.app/",
    },
    {
      title: "Food Business Startup",
      description: "Serve & satisfy",
      imgUrl: fd,
      hostlink:"https://platefullfoodorderingsite.netlify.app/",
    }
  ];

   
  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>These modern websites are made using React, Redux, and Tailwind, which are all modern web development tools. 
                They also implemented Login-Sign up authentication using Firebase and ensured that the website was 
                optimized for speed and user experience.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                   
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""} >
                  
                    <Tab.Pane eventKey="first">
                    
                      <Row> 
                        {
                          projects.map((project, index) => { 
                            
                            return (

                              <ProjectCard
                              key={index}
                              {...project}
                              /> 
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} ></img>
    </section>
  )
}